/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {BaseInstance} from './base-instance';
import {Reader} from './reader';
import {LocationInstance} from './location-instance';
import {ZoneInstance} from './zone-instance';
import {Point} from './point';

export class ReaderInstance extends BaseInstance {
  reader: Reader;
  location: LocationInstance;
  zone: ZoneInstance;
  position: Point;
}
